import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  AppSuiteGroup,
  PersonalTask,
  useGetGroupsQuery,
} from "graphql/generated/schema-types";
import { useGetGroupsById } from "hooks/cacheAccessHooks";
import React, { ChangeEvent, useState } from "react";

interface AssignToGroupsProps {
  isOpen: boolean;
  handleClose: (assignedGroups: number[], assignGroup: boolean) => void;
  selectedTask: PersonalTask;
}

export const AssignToGroupsDialog = ({
  isOpen,
  handleClose,
  selectedTask,
}: AssignToGroupsProps) => {
  const [selectedGroups, setSelectedGroups] = useState<AppSuiteGroup[] | null>(
    null,
  );
  const assignedGroups = useGetGroupsById(
    (selectedTask?.groups ?? [])
      .map((group) => group?.groupId)
      .filter((groupId): groupId is number => groupId != null),
  );
  const displayedGroups = selectedGroups ?? assignedGroups ?? [];
  const groupsQuery = useGetGroupsQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-first",
  });

  const handleSubmit = () => {
    const groupIds = displayedGroups
      .map((group) => group?.groupId)
      .filter((groupId): groupId is number => groupId != null);
    handleClose(groupIds, true);
  };

  const clearSelectedGroups = () => {
    setSelectedGroups(null);
    handleClose([], false);
  };
  return (
    <>
      <Dialog open={isOpen} onClose={() => clearSelectedGroups()}>
        <DialogTitle>Groups Assigned To Group(s)</DialogTitle>
        <DialogContent>
          <ul>
            <li>{selectedTask.taskName}</li>
          </ul>
          <Autocomplete
            multiple
            id="tags-outlined"
            options={
              groupsQuery.data?.appSuiteGroups?.map((node) => node) ?? []
            }
            getOptionLabel={(option) => option!.groupName!}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" />
            )}
            onChange={(event: ChangeEvent<unknown>, newValue: any) =>
              setSelectedGroups(newValue ?? [])
            }
            value={displayedGroups}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
